export const COUNTRY_OPTIONS = [
    { code: 'SWE', name: 'Sweden', currency: 'SEK', flag: '🇸🇪' },
    { code: 'POL', name: 'Poland', currency: 'PLN', flag: '🇵🇱' },
    { code: 'FRA', name: 'France', currency: 'EUR', flag: '🇫🇷' },
    { code: 'DEU', name: 'Germany', currency: 'EUR', flag: '🇩🇪' },
    { code: 'ITA', name: 'Italy', currency: 'EUR', flag: '🇮🇹' },
    { code: 'ESP', name: 'Spain', currency: 'EUR', flag: '🇪🇸' },
    { code: 'NLD', name: 'Netherlands', currency: 'EUR', flag: '🇳🇱' },
    { code: 'BEL', name: 'Belgium', currency: 'EUR', flag: '🇧🇪' },
    { code: 'AUT', name: 'Austria', currency: 'EUR', flag: '🇦🇹' },
    { code: 'PRT', name: 'Portugal', currency: 'EUR', flag: '🇵🇹' },
    { code: 'GRC', name: 'Greece', currency: 'EUR', flag: '🇬🇷' },
    { code: 'IRL', name: 'Ireland', currency: 'EUR', flag: '🇮🇪' },
    { code: 'FIN', name: 'Finland', currency: 'EUR', flag: '🇫🇮' },
    { code: 'GBR', name: 'United Kingdom', currency: 'GBP', flag: '🇬🇧' },
    { code: 'JPN', name: 'Japan', currency: 'JPY', flag: '🇯🇵' },
    { code: 'ZAF', name: 'South Africa', currency: 'ZAR', flag: '🇿🇦' },
    { code: 'MKD', name: 'North Macedonia', currency: 'MKD', flag: '🇲🇰' },
    { code: 'USA', name: 'United States', currency: 'USD', flag: '🇺🇸' }
].sort((a, b) => a.name.localeCompare(b.name));

export const INITIAL_STATE = {
    countryCode: '',
    teamId: '',
    tier: '',
    monthlyPrice: '',
    monthlyDiscount: '',
    yearlyPrice: '',
    yearlyDiscount: '',
    isActive: true,
    pointMultiplier: 1.0,
    features: [],
    p4pPercent: 50,
    teamPercent: 50,
    athletePercent: 0,
    vatPercent: 0
};

export const SYNC_STYLES = {
    synced: { bg: 'bg-[#e8faf2]', dot: 'bg-[#27E3A3]', text: 'text-[#059669]' },
    pending: { bg: 'bg-[#fef9e7]', dot: 'bg-[#eab308]', text: 'text-[#b59500]' },
    error: { bg: 'bg-[#FFECEE]', dot: 'bg-[#FA3F58]', text: 'text-[#FA3F58]' }
};
